export function formatCount(value: number): string {
  if (value >= 100000) {
    return `${(value / 10000).toFixed(1)} 万`;
  }
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)} 万`;
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}k`;
  }
  return `${value}`;
}

export function formatDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}